import styled from "styled-components";
import Button from "@material-ui/core/Button";
import getMeta from "../services/getMetaFromCmId";
import getImage from "../services/getImage";
import getLinkMeta from "../services/getMetaFromLink";

import { useState } from "react";
import { SingleNFT } from "./SingleNFT";
import { Modal, Container, Tooltip } from "@material-ui/core";

interface SingleMetadata {
  name: string;
  link: string;
}
export const CTAButton = styled(Button)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #550041 0%, #e1694c 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
`; // add your own styles here

const chunk = (arr: any[], size: number) => arr.reduce((acc: any[], e: any, i: number) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);


const isURL = (_string: string) => {
  const matchPattern = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return matchPattern.test(_string);
}

const renderImageVerification = (processedVerificationCounter: number[], failedVerificationImages: any, displayLength: number, setDisplayLength: any) => {
  const toDisplay = failedVerificationImages.slice(0, displayLength);

  return (<div className="gif-grid">
    <Container maxWidth="xl" style={{ position: "relative", color: "white", marginBottom: "10px" }}>
      <div key='-1'>
        Success: {processedVerificationCounter[0]} Failed: {processedVerificationCounter[1]} Out of: {processedVerificationCounter[2]}
      </div>
    </Container>

    {toDisplay?.map((item: any, index: number) => (
      <Container maxWidth="xl" style={{ position: "relative", color: "white" }}>
        <div key={index}>
          Failed verification for: <a href={item.arweaveLink} target="_blank" rel="noreferrer">{item.name}</a><br/>
         <span style={{color: "grey"}}> {item.failure && item.failure.toString()}</span><br/> <br/> 
        </div>
      </Container>
    ))}

    <Container maxWidth="xs" style={{ position: "relative", color: "white" }}>
      <div key='-2'>

        <CTAButton onClick={setDisplayLength.bind(setDisplayLength, displayLength + 10)} disabled={toDisplay.length === 0 || toDisplay.length >= failedVerificationImages.length}>
          {toDisplay.length === 0 || toDisplay.length >= failedVerificationImages.length ? "Nothing to show" : "Load More"}
        </CTAButton>
      </div>
    </Container>
  </div>)
}

const renderMetaData = (metadata: any) => {
  return (
    <div className="gif-grid">
      {metadata?.map((item: SingleMetadata, index: number) => (
        <Container maxWidth="xs" style={{ position: "relative" }}>
          <div key={index}>
            <SingleNFT item={item}></SingleNFT>
          </div>
        </Container>
      ))}
    </div>
  );
};

let data: Array<SingleMetadata>;
export const MetadataFromCM = ({
  cmAddress,
  disabled,
  rpcAddress,
  metadata,
  setMetadata
}: {
  cmAddress: string;
  disabled: boolean;
  rpcAddress: string;
  metadata: Array<SingleMetadata>
  setMetadata:any;
}) => {
  
  const [displayLength, setDisplayLength] = useState(10);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageVerificationOpen, setImageVerificationOpen] = useState(false);
  const [failedVerificationImages, setFailedVerificationImages] = useState([] as any);
  const [processedVerificationCounter, setProcessedVerificationCounter] = useState([0, 0, 0]);

  const handleClose = () => {
    setOpen(false);
    setImageVerificationOpen(false);
  };

  const handleImageVerification = async () => {
    setLoading(true);
    data = await getMeta(cmAddress, rpcAddress);

    setLoading(false);
    setImageVerificationOpen(true);

     await new Promise((resolve) => {
      let failedVerification: any = []
      let countSuccess = 0;
      let countFailed = 0;
      let allImages = data.length;

      setProcessedVerificationCounter([countSuccess, countFailed, allImages]);


      chunk(data, Math.floor(data.length / 50)).forEach(async (c: any) => {
        for (const item of c) {
          let failed = false;
          const remoteMeta = await getLinkMeta(item["link"]);

          remoteMeta.arweaveLink = item["link"];
          remoteMeta.failure = []
          if (!remoteMeta || !remoteMeta.image || !remoteMeta.properties?.files?.[0].uri || !isURL(remoteMeta.image) || !isURL(remoteMeta.properties.files[0].uri) || remoteMeta.image !== remoteMeta.properties.files[0].uri) {
            failed = true;
            if (!isURL(remoteMeta.image)) {remoteMeta.failure = [...remoteMeta.failure,"No URL in `image` field"];}
            if (!isURL(remoteMeta.properties.files[0].uri)) {remoteMeta.failure = [...remoteMeta.failure,"No URL in `properties/files` field"];}
            if ( remoteMeta.image !== remoteMeta.properties.files[0].uri) {remoteMeta.failure = [...remoteMeta.failure,"URLs in `image` and `files` are different"];}
           
          }

          if (!failed) {
            const mainImage = await getImage(remoteMeta.image);
            if (mainImage.status !== 200 || !mainImage.ok) {
              failed = true;
              remoteMeta.failure = [...remoteMeta.failure,"Can't fetch image"];
            }
          }

          if (failed) {
            countFailed++
            failedVerification.push(remoteMeta);
            setFailedVerificationImages(failedVerification.sort((a: any, b: any) => Number(a.name.split('#').pop()) - Number(b.name.split('#').pop())))
          } else {
            countSuccess++;
          };

          setProcessedVerificationCounter([countSuccess, countFailed, allImages]);
        }
      });
    })
  };

  const handleClick = async () => {
    setLoading(true);
    data = await getMeta(cmAddress, rpcAddress);
    setMetadata(data);
    setLoading(false);
    setOpen(true);
  };

  return (
    <>
      <Tooltip title={disabled ? "Set CM address and select network!" : "Click to get metadata links form CM onchain config"}><span>
        <CTAButton onClick={handleClick} disabled={disabled || loading}>
          Get Meta
        </CTAButton></span>
      </Tooltip>

      <Tooltip title={disabled ? "Set CM address and select network!" : "Click to get metadata links form CM onchain config"}><span>
        <CTAButton onClick={handleImageVerification} disabled={disabled || loading}>
          Verify Images
        </CTAButton></span>
      </Tooltip>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          width: "50%",
          marginTop: "30px",
          marginLeft: "30px",
          height: "100%",
        }}
      >
        <div className="terminal">
          <section className="terminal__bar">
            <div className="bar__buttons">
              <button
                className="bar__button bar__button--exit"
                onClick={handleClose}
              >
                &#10005;
              </button>
              <button className="bar__button">&#9472;</button>
              <button className="bar__button">&#9723;</button>
            </div>
            <p className="bar__user">CMmeta@ubuntu: ~</p>
          </section>

          <section
            className="terminal__body"
            style={{ maxHeight: "100%", overflow: "auto" }}
          >
            <div className="terminal__prompt">
              <span className="terminal__prompt--user">CMmeta@ubuntu:</span>
              <span className="terminal__prompt--location">~</span>

              <span className="terminal__prompt--bling">$</span>
              {data && renderMetaData(metadata)}
              <span className="terminal__prompt--cursor"></span>
            </div>
          </section>
        </div>
      </Modal>


      <Modal
        open={imageVerificationOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          width: "50%",
          marginTop: "30px",
          marginLeft: "30px",
          height: "100%",
        }}
      >
        <div className="terminal">
          <section className="terminal__bar">
            <div className="bar__buttons">
              <button
                className="bar__button bar__button--exit"
                onClick={handleClose}
              >
                &#10005;
              </button>
              <button className="bar__button">&#9472;</button>
              <button className="bar__button">&#9723;</button>
            </div>
            <p className="bar__user">CMmeta@ubuntu: ~</p>
          </section>

          <section
            className="terminal__body"
            style={{ maxHeight: "100%", overflow: "auto" }}
          >
            <div className="terminal__prompt">
              <span className="terminal__prompt--user">CMmeta@ubuntu:</span>
              <span className="terminal__prompt--location">~</span>

              <span className="terminal__prompt--bling">$</span>
              {renderImageVerification(processedVerificationCounter, failedVerificationImages, displayLength, setDisplayLength.bind(this))}
              <span className="terminal__prompt--cursor"></span>
            </div>
          </section>
        </div>
      </Modal>
    </>
  );
};
